/* Wishifyy - holiday order-deadline banner.
   Pulls the computed "order by" deadline from the CRM worker and surfaces it in
   two native spots:
     1) the cart-drawer announcement carousel (.cd-ann-msgs) - as an extra
        rotating message;
     2) the product page - a card right above the "Гравюрата отнема…" notice,
        styled to match it (so it sits between the buy button and that notice).
   Purely additive + defensive: any failure is swallowed; the page is untouched.
   Config + deadline managed in CRM → Празничен календар → „Срокове за поръчки". */
(function () {
  var API = 'https://wishifyy-crm.wishifycom.workers.dev/api/holidays/deadline';
  var SHOW_WITHIN_DAYS = 30;

  function fmtDate(iso) {
    try { return new Intl.DateTimeFormat('bg-BG', { day: 'numeric', month: 'long' }).format(new Date(iso + 'T00:00:00')); }
    catch (e) { return iso; }
  }
  function messageFor(p) {
    if (p.passed) return 'Срокът за „' + p.name + '" мина - поръчай сега, ще се постараем да стигне навреме';
    return 'Поръчай до ' + fmtDate(p.order_by) + ', за да получиш до „' + p.name + '"';
  }
  var CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="17" height="17" aria-hidden="true" style="flex:none;"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';

  // 1) Announcement carousel - clone the strip, append our message, run our own
  //    rotation. Cloning detaches the native timer's static NodeList (it keeps
  //    toggling now-orphaned nodes, harmlessly), so ours is the visible one.
  function injectAnnouncement(msg) {
    var el = document.querySelector('.cd-ann-msgs');
    if (!el || el.getAttribute('data-wf-deadline')) return;
    var clone = el.cloneNode(true);
    clone.setAttribute('data-wf-deadline', '1');
    var span = document.createElement('span');
    span.className = 'cd-ann-msg';
    span.innerHTML = '⏰ ' + msg;
    clone.appendChild(span);
    el.parentNode.replaceChild(clone, el);
    var all = clone.querySelectorAll('.cd-ann-msg');
    if (!all.length) return;
    var i = 0;
    all.forEach(function (m, k) { m.classList.toggle('active', k === 0); });
    if (all.length > 1) {
      setInterval(function () {
        all[i].classList.remove('active');
        i = (i + 1) % all.length;
        all[i].classList.add('active');
      }, 4200);
    }
  }

  // 2) Product page - a card matching the engraving-notice look, inserted right
  //    before that notice (so it lands between the buy button and the notice).
  function injectProduct(msg, urgent) {
    if (document.getElementById('wf-deadline-pdp')) return;
    var noticeText = document.querySelector('.mpv2__embroidery-notice-text');
    // The container is the notice's PARENT (svg + text); insert our card before
    // it so it sits between the buy button and the "Гравюрата отнема…" notice.
    var notice = noticeText ? (noticeText.closest('.mpv2__embroidery-notice') || noticeText.parentElement) : null;
    if (!notice || !notice.parentNode) return;
    var bg = urgent ? '#6B1E32' : '#FFF7E8';
    var fg = urgent ? '#ffffff' : '#6B1E32';
    var border = urgent ? '#6B1E32' : '#FFA628';
    var card = document.createElement('div');
    card.id = 'wf-deadline-pdp';
    card.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;margin:10px 0;padding:10px 14px;' +
      'text-align:center;border-radius:10px;font-size:13.5px;font-weight:600;line-height:1.4;background:' + bg + ';color:' + fg +
      ';border:1px solid ' + border + ';';
    card.innerHTML = CLOCK + '<span>' + msg + '</span>';
    notice.parentNode.insertBefore(card, notice);
  }

  // Банерът се показва само за ГОЛЕМИТЕ празници (заявка 2026-07-30) - Коледа,
  // Нова година, Великден, св. Валентин, 8 март + големите именни дни. По-малките
  // поводи от Празничния календар не вадят банер.
  var MAJOR = /Коледа|Нова година|Великден|Валентин|8 март|Ден на майката|Цветница|Гергьовден|Ивановден|Йордановден|Никулден|Димитровден|Архангеловден|Петровден|Стефановден/i;
  function render(d) {
    if (!d || !d.enabled || !d.primary) return;
    var p = d.primary;
    if (!p.passed && p.days_left > SHOW_WITHIN_DAYS) return;
    if (!MAJOR.test(p.name || '')) return;
    var msg = messageFor(p);
    try { injectAnnouncement(msg); } catch (e) {}
    // PDP инжекцията е премахната - на нейно място стои статичният ред
    // „За спешни случаи се обади на…" (в main-product-v2.liquid).
  }

  function go() {
    try { fetch(API, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(render).catch(function () {}); }
    catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
